export const RESPONSE_HEADERS = {
  CURRENT_PAGE: 'x-current-page',
  ELEMENTS_PER_PAGE: 'x-elements-per-page',
  TOTAL_COUNT: 'x-total-count',
  TOTAL_PAGES: 'x-total-pages',
}
